const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

// Helper function for API requests
export const apiRequest = async (endpoint, options = {}) => {
    // Get token from localStorage
    const token = localStorage.getItem('token');

    // Set default headers
    const headers = {
        'Content-Type': 'application/json',
        ...options.headers
    };

    // Add authorization header if token exists
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    // Set credentials to include for cookies
    const config = {
        ...options,
        headers,
        credentials: 'include'
    };

    try {
        const response = await fetch(`${API_URL}${endpoint}`, config);
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data;
    } catch (error) {
        console.error('API request failed:', error);
        throw error;
    }
};

// Auth API
export const authAPI = {
    login: (credentials) => apiRequest('/auth/login', {
        method: 'POST',
        body: JSON.stringify(credentials)
    }),

    logout: () => apiRequest('/auth/logout'),

    getProfile: () => apiRequest('/auth/me'),

    updatePassword: (passwords) => apiRequest('/auth/password/update', {
        method: 'PUT',
        body: JSON.stringify(passwords)
    })
};

// Projects API
export const projectsAPI = {
    getAll: (params = {}) => {
        const queryParams = new URLSearchParams();

        if (params.world) queryParams.append('world', params.world);
        if (params.featured) queryParams.append('featured', params.featured);
        if (params.limit) queryParams.append('limit', params.limit);

        const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
        return apiRequest(`/projects${query}`);
    },

    getById: (id) => apiRequest(`/projects/${id}`),

    create: (project) => apiRequest('/projects', {
        method: 'POST',
        body: JSON.stringify(project)
    }),

    update: (id, project) => apiRequest(`/projects/${id}`, {
        method: 'PUT',
        body: JSON.stringify(project)
    }),

    delete: (id) => apiRequest(`/projects/${id}`, {
        method: 'DELETE'
    })
};

// Personal Info API
export const personalInfoAPI = {
    get: () => apiRequest('/personal-info'),

    update: (data) => apiRequest('/personal-info', {
        method: 'PUT',
        body: JSON.stringify(data)
    })
};

// Testimonials API
export const testimonialsAPI = {
    getAll: (params = {}) => {
        const queryParams = new URLSearchParams();

        if (params.world) queryParams.append('world', params.world);
        if (params.featured) queryParams.append('featured', params.featured);
        if (params.limit) queryParams.append('limit', params.limit);

        const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
        return apiRequest(`/testimonials${query}`);
    },

    getById: (id) => apiRequest(`/testimonials/${id}`),

    create: (testimonial) => apiRequest('/testimonials', {
        method: 'POST',
        body: JSON.stringify(testimonial)
    }),

    update: (id, testimonial) => apiRequest(`/testimonials/${id}`, {
        method: 'PUT',
        body: JSON.stringify(testimonial),

    }),

    delete: (id) => apiRequest(`/testimonials/${id}`, {
        method: 'DELETE'
    }),

    approve: (id) => apiRequest(`/testimonials/${id}/approve`, {
        method: 'PATCH'
    })
};

export default {
    auth: authAPI,
    projects: projectsAPI,
    personalInfo: personalInfoAPI,
    testimonials: testimonialsAPI
}; 